import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initInteractions() {
  initArchitectureToggle();
}

function initArchitectureToggle() {
  const toggle = document.querySelector('.architecture-toggle');
  if (!toggle) return;
  
  const btns = toggle.querySelectorAll('.toggle-btn');
  const cards = document.querySelectorAll('.field-note-card');
  
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const view = btn.dataset.view;
      toggle.dataset.state = view;
      
      cards.forEach(card => {
        const front = card.querySelector('.face-front');
        const back = card.querySelector('.face-back');
        if (!front || !back) return;
        
        if (view === 'architecture') {
          gsap.to(front, { opacity: 0, y: -10, duration: 0.3, onComplete: () => {
            front.style.display = 'none';
            back.style.display = 'block';
            gsap.fromTo(back, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.3 });
          }});
        } else {
          gsap.to(back, { opacity: 0, y: 10, duration: 0.3, onComplete: () => {
            back.style.display = 'none';
            front.style.display = 'block';
            gsap.fromTo(front, { opacity: 0, y: -10 }, { opacity: 1, y: 0, duration: 0.3 });
          }});
        }
      });
    });
  });
}
